// src/services/zoomBroadcast.ts
// Admin-only "Zoom Broadcast" API client.

export type RosterEntry = {
  email: string;
  uid: string;
  name: string;
};

export type RosterResponse = {
  roster: RosterEntry[];
  count: number;
  cachedAt: string;
  source: 'cache' | 'live';
};

export type SendBroadcastInput = {
  recipients?: string[];
  broadcastAll?: boolean;
  title?: string;
  message: string;
  linkLabel?: string;
  linkUrl?: string;
};

export type SendBroadcastResult = {
  ok: boolean;
  sentTo: number;
  broadcastAll: boolean;
};

async function apiFetch<T>(path: string, opts?: RequestInit): Promise<T> {
  const r = await fetch(path, { credentials: 'include', cache: 'no-store', ...opts });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error((data as { error?: string })?.error || `HTTP ${r.status}`);
  return data as T;
}

export function getRoster(refresh = false): Promise<RosterResponse> {
  return apiFetch<RosterResponse>(`/api/zoom-broadcast${refresh ? '?refresh=1' : ''}`);
}

export function sendBroadcast(input: SendBroadcastInput): Promise<SendBroadcastResult> {
  return apiFetch<SendBroadcastResult>('/api/zoom-broadcast', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
}
